const InfoIcon = () => (
  <svg
    width="11"
    height="18"
    viewBox="0 0 11 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 17.5367V15.9558H4.176V7.31996H0V5.73909H6.096V15.9558H10.176V17.5367H0ZM3.528 
             2.38858C3.528 1.96387 3.672 1.60207 3.96 1.3032C4.248 0.9886 
             4.616 0.831299 5.064 0.831299C5.528 0.831299 5.912 0.9886 6.216 
             1.3032C6.536 1.60207 6.696 1.96387 6.696 2.38858C6.696 2.79756 6.536 
             3.14362 6.216 3.42676C5.912 3.70991 5.528 3.85148 5.064 3.85148C4.616 
             3.85148 4.248 3.70991 3.96 3.42676C3.672 3.14362 3.528 2.79756 3.528 2.38858Z"
      fill="#5B88BD"
    />
  </svg>
);
export default InfoIcon;
